var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "maintenanace" } }, [
    _vm.device == "desktop"
      ? _c("h1", [_vm._v(_vm._s(_vm.$t("maintenance")))])
      : _vm._e(),
    _vm.device != "desktop"
      ? _c("h1", [_vm._v(_vm._s(_vm.$t("maintenance_phone")))])
      : _vm._e(),
    _c("img", {
      attrs: { src: "https://e-rovinieta.ro/media/maintenance.jpg" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }